import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { GetColumnConfigResponse } from '@erp/rpc';

export function useOrgTableColumnConfig(tableId: string) {
  return useQuery(
    orpc.core.orgTableColumnConfigs.get.queryOptions({
      input: { tableId },
    }),
  );
}

export function useUpsertOrgTableColumnConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rpcClient.core.orgTableColumnConfigs.upsert,
    onSuccess: (data, variables) => {
      const queryKey = orpc.core.orgTableColumnConfigs.get.queryKey({
        input: { tableId: variables.tableId },
      });
      queryClient.setQueryData<GetColumnConfigResponse>(queryKey, data);
    },
  });
}
